export default __webpack_public_path__ + "static/media/icon-highlight-monetary.1dfd6ba9.svg";